import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import { UTILITIES_PATHS } from './UtilitiesConstants'
import Loading from 'egret/components/EgretLoadable/Loading'

const Color = EgretLoadable({
  loader: async () => await import('./Color')
})

const utilitiesRoutes: RouteConfig[] = [
  {
    path: UTILITIES_PATHS.COLOR,
    component: Color
  }
]

export default utilitiesRoutes
